import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'timeslot_kind_exception_guid': 'String!',
	'team_guid': '[String]',
};

export default gql(`
	mutation timeslot_kind_exception_to_teams( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind_exception_to_teams( ${ HelperGraphql.createVariables( fields ) } ) {
	        teams {
	            guid
	        }
	    }
	}
`);

